import styled, { css } from 'styled-components';

import { Typography } from '@speeki/global-ui-components';
import { IconButton } from '@speeki/icons';

import { breakpoints } from '@shared/constants';

export const ReportUploadWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-bottom: 56px;
`;

export const UploadText = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        text-align: center;
    `,
);

export const UploadTextWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 4px;
`;

export const CloseIcon = styled(IconButton)`
    cursor: pointer;
`;

export const List = styled.ul`
    margin: 0 auto;
    max-width: 500px;
    padding: 32px 0 0 0;
    width: 100%;

    @media (max-width: ${breakpoints.md}px) {
        max-width: 380px;
    }

    & + & {
        padding-top: 0;
    }
`;
export const ListItem = styled.li`
    display: flex;
    padding-top: 16px;
`;

export const BorderWrapper = styled.div(
    ({ theme: { palette } }) => css`
        align-items: center;
        border-bottom: 1px solid ${palette.neutral.dividers};
        display: flex;
        flex: 1;
        justify-content: space-between;
        margin-left: 8px;
        min-width: 200px;
        padding-bottom: 16px;
    `,
);

export const Text = styled(Typography.TextBody_14_20)`
    max-width: 380px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;

    @media (max-width: ${breakpoints.md}px) {
        max-width: 200px;
    }
`;

export const InfoText = styled(Typography.TextBody_14_20)(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        flex: 1;
        margin-left: 8px;
        min-width: 80px;
    `,
);
